import { render, staticRenderFns } from "./points-order.vue?vue&type=template&id=07003552"
import script from "./points-order.vue?vue&type=script&lang=js"
export * from "./points-order.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports